<template>
  <footer class="footer">
    <b-container class="bg-road-container">
      <b-row class="flex-row-reverse flex-md-row">
        <b-col sm="12">
          <h4 class="footer-title-section">{{$t('road_grexy')}}</h4>
        </b-col>
        <b-col sm="12" md="4" order="3" order-md="1">
          <div class="box-road">
            <p class="date">2023</p>
            <div class="icon-container fist-road-box">
              <img class="footer-icon" src="../assets/img/new-content/check-footer-icon.svg" alt="icon">
              <hr class="dots-liner">
            </div>
            <p class="title-road-box">{{$t('road_title_1')}}</p>
          </div>
        </b-col>
        <b-col sm="12" md="4" order="2">
          <div class="box-road shadow-box">
            <p class="date">2024</p>
            <div class="icon-container second-road-box">
              <img class="footer-icon" src="../assets/img/new-content/mini-logo-grexy.svg" alt="icon">
              <hr class="dots-liner">
            </div>
            <p class="title-road-box">{{$t('road_title_2')}}</p>
            <ul class="list-container">
              <li>
                <img class="footer-icon" src="../assets/img/new-content/hous-icon.svg" alt="icon">
                <span>{{$t('road_list_1')}}</span>
              </li>
              <li>
                <img class="footer-icon" src="../assets/img/new-content/rules-Icon.svg" alt="icon">
                <span>{{$t('road_list_2')}}</span>
              </li>
              <li>
                <img class="footer-icon" src="../assets/img/new-content/message-people-icon.svg" alt="icon">
                <span>{{$t('road_list_3')}}</span>
              </li>
              <li>
                <img class="footer-icon" src="../assets/img/new-content/news-feed-icon.svg" alt="icon">
                <span>{{$t('road_list_4')}}</span>
              </li>
              <li>
                <img class="footer-icon" src="../assets/img/new-content/map-icon.svg" alt="icon">
                <span>{{$t('road_list_5')}}</span>
              </li>
            </ul>
          </div>
        </b-col>
        <b-col sm="12" md="4" order="1" order-md="3">
          <div class="box-road">
            <p class="date">2025</p>
            <div class="icon-container fist-road-box">
              <img class="footer-icon" src="../assets/img/new-content/Subtract.svg" alt="icon">
              <hr class="dots-liner">
            </div>
            <p class="title-road-box">{{$t('road_title_3')}}</p>
            <ul class="list-container">
              <li>
                <img class="footer-icon" src="../assets/img/new-content/comming-soon.svg" alt="icon">
              </li>
              <li>
                <img class="footer-icon" src="../assets/img/new-content/Expert.svg" alt="icon">
                <span>{{$t('road_list_6')}}</span>
              </li>
              <li>
                <img class="footer-icon" src="../assets/img/new-content/ai-footer-icon.svg" alt="icon">
                <span>{{$t('road_list_7')}}</span>
              </li>
              <li>
                <img class="footer-icon" src="../assets/img/new-content/vet-pass.svg" alt="icon">
                <span>{{$t('road_list_8')}}</span>
              </li>
              <li>
                <img class="footer-icon" src="../assets/img/new-content/footer-grexy-game-icon.svg" alt="icon">
                <span>{{$t('road_list_9')}}</span>
              </li>
            </ul>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="position-relative">
      <b-row>
        <b-col sm="12">
          <hr class="line">
        </b-col>
        <b-col sm="12" md="6">
          <div class="footer-logo-container">
            <div class="footer-logo-container">
              <router-link to="/" class="logo-link">
                <img class="footer-logo-img" src="../assets/img/white-logo-grexy.svg" alt="Logo Grexy">
                <span class="logo-text">Grexy</span>
              </router-link>
            </div>
            <language-switcher class="footer-switcher"></language-switcher>
          </div>
        </b-col>
        <b-col sm="12" md="4" offset-md="2">
          <div class="address-container">
            <div class="social-container">
              <a href="https://www.linkedin.com/company/grexyapp/" target="_blank" class="address-link">
                <img class="footer-logo-img" src="../assets/img/in.svg" alt="linkedin">
              </a>
            </div>
            <address>
              <p>Ukraine, Lviv</p>
              <!--<a href="https://maps.app.goo.gl/oPq9DHoufVxmxp4VA" target="_blank" class="address-link">-->
              <!--  {{$t('address')}}-->
              <!--</a>-->
              <!--<a href="tel:+0800384953" class="address-link">0800384953</a>-->
              <a href="mailto:info@grexy.co" class="address-link">info@grexy.co</a>
            </address>
          </div>
        </b-col>
        <b-col sm="12">
          <div class="useful-links">
            <a href="https://doc-hosting.flycricket.io/grexy-privacy-policy/af4c254a-2ef0-4785-b52c-bd7803225773/privacy" target="_blank" class="footer-link">
              Privacy Policy
            </a>
            |
            <a href="https://doc-hosting.flycricket.io/grexy-terms-of-use/e13a9d6f-ef13-48e3-b87d-32e1c917b8dc/terms" target="_blank" class="footer-link">
              Terms & Conditions
            </a>
            |
            <router-link to="/eula"  class="footer-link" style="white-space: nowrap;">{{$t('eula_link')}}</router-link>
          </div>
        </b-col>
      </b-row>
      <b-row class="copyright-section">
        <b-col sm="12">
          <p class="copyright-container">
            &copy; Grexy {{ currentYear }}. {{$t('all_rights_reserved')}}
          </p>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>
<script>
import LanguageSwitcher from '@/components/LanguageSwitcher'
export default {
  components: {
    LanguageSwitcher
  },
  data () {
    return {
      currentYear: new Date().getFullYear()
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/sass/app.scss";
.footer{
  padding: 80px 0;
  background: radial-gradient(56.79% 107.89% at 70.64% -15.07%, #8184F9 12.26%, #5C5EE8 91.15%);
  position: relative;
  @media screen and (min-width: 320px) {
    padding: 80px 0 40px 0;
  }
  @media screen and (min-width: 374px) {
  }
  @media screen and (min-width: 425px) {
  }
  @media screen and (min-width: 768px) {
  }
  @media screen and (min-width: 992px) {
    padding: 80px 0;
  }
  @media screen and (min-width: 1440px) {
  }
  @media screen and (min-width: 1920px) {
  }
  &:before{
    content: '';
    display: flex;
    width: 246px;
    height: 238px;
    background: url('../assets/img/new-content/Isolation_Mode.png');
    position: absolute;
    top: 176px;
    right: 0;
    @media screen and (min-width: 320px) {
      width: 123px;
      height: 120px;
      top: 155px;
      right: 0;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: contain;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
      width: 246px;
      height: 238px;
      top: 176px;
      right: 0;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
  }
  .footer-title-section{
    font-family: $main-font;
    color: #FFFFFF;
    font-size: 40px;
    font-weight: 700;
    line-height: 48px;
    text-align: left;
    margin: 0 0 48px 0;
    @media screen and (min-width: 320px) {
      font-size: 32px;
      font-weight: 700;
      line-height: 38.4px;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
      font-size: 40px;
      font-weight: 700;
      line-height: 48px;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
  }
  .box-road{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 9px;
    width: 100%;
    padding: 16px;
    @media screen and (min-width: 320px) {
      margin-bottom: 40px;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
      margin-bottom: 0;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
    .date{
      font-family: $main-font;
      font-size: 20px;
      font-weight: 700;
      line-height: 28px;
      text-align: left;
      color: #ffffff;
      margin: 0;
    }
    .icon-container{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 80px;
      width: 100%;
      .dots-liner{
        width: 100%;
        border-top: 6.5px dotted #ffffff;
      }
    }
    .icon-container.fist-road-box{
      .footer-icon{
        width: 40px;
        height: 40px;
      }
    }
    .icon-container.second-road-box{
      .footer-icon{
        width: 64px;
        height: 64px;
      }
    }
    .title-road-box{
      font-family: $main-font;
      color: #ffffff;
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
      text-align: left;
      margin: 0;
    }
    .list-container{
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 9px;
      list-style-type: none;
      margin: 0;
      padding: 0;
      li{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 9px;
        font-family: $main-font;
        font-size: 16px;
        font-weight: 400;
        line-height: 19.2px;
        text-align: left;
        color: #ffffff;
      }
    }
  }
  .shadow-box{
    border-radius: 16px;
    background: linear-gradient(29.66deg, rgba(255, 255, 255, 0.08) 17.91%, rgba(255, 255, 255, 0.16) 99.79%);
  }
  .line{
    border-color: #FFFFFF80;
    margin-bottom: 56px;
  }
  .footer-logo-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 56px;
    @media screen and (min-width: 320px) {
      gap: 25px;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
      gap: 56px;
    }
    @media screen and (min-width: 992px) {
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
    .logo-link{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      &:hover{
        text-decoration: none;
      }
      .footer-logo-img{
        width: 50px;
        height: 50px;
        margin-right: 16px;
      }
      .logo-text{
        color: #FFF;
        font-family: $main-font;
        font-size: 40px;
        font-style: normal;
        font-weight: 700;
        line-height: 48px;
      }
    }
    .footer-switcher{
      margin-top: 10px;
      background: #ffffff;
    }
  }
  .address-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 16px;
    margin-top: 16px;
    @media screen and (min-width: 320px) {
      margin-top: 32px;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
      margin-top: 16px;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
    .social-container{
      .social-link {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        padding: 7px;
      }
    }
    address {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      margin: 0;
      color: #FFF;
      font-family: $main-font;
      font-size: 16px;
      font-style: normal;
      font-weight: 300;
      line-height: 22px;
      p{
        margin: 0;
      }
      .address-link{
        color: #FFF;
        font-family: $main-font;
        font-size: 16px;
        font-style: normal;
        font-weight: 300;
        line-height: 22px;
        &:hover{
          text-decoration: none;
        }
      }
    }
  }
  .copyright-section{
    margin-top: 80px;
    @media screen and (min-width: 320px) {
      margin-top: 0;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
      margin-top: 80px;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
  }
  .copyright-container{
    color: #FFF;
    font-family: $main-font;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    margin: 0;
    text-align: center;
  }
  .useful-links{
    color: #FFF;
    position: relative;
    top: -24px;
    @media screen and (min-width: 320px) {
      top: unset;
      margin-top: 32px;
      margin-bottom: 24px;
    }
    @media screen and (min-width: 374px) {
    }
    @media screen and (min-width: 425px) {
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
      top: -24px;
      margin-top: unset;
      margin-bottom: unset;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
    .footer-link{
      color: #FFF;
      font-family: $main-font;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px;
      text-decoration: none;
    }
  }
}
</style>
